<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card no-shadow mt-0">
            <div class="
                card-header card-header-primary
                negative
                blue-grad
                w-50
                d-flex
                flex-column
              ">
              <h4 class="card-title">
                {{ $t("message.find_person.title") }}
              </h4>
              <div class="card-body w-100 mt-3">
                <b-tabs pills content-class="mt-3" small v-model="tab_index">
                  <b-tab :title="$t('message.find_person.search')" active id="search-tab">
                    <div class="input-group find-person-input-group">
                      <input type="text" class="form-control" style="height: 50px" :disabled="isSearching"
                        :placeholder="$t('message.find_person.search_name_placeholder')" v-model="searchInputName"
                        autocomplete="off" />
                      <input type="text" class="form-control" style="height: 50px" :disabled="isSearching"
                        :placeholder="$t('message.find_person.search_id_placeholder')" v-model="searchInputId"
                        autocomplete="off" />
                      <v-select-popup :indata="all_types" v-model="type" inputHeight="50px" inputBackground="#fff"
                        inputBorderRadius="0px" :disabled="isSearching"
                        :placeholder="$t('message.find_person.search_type_placeholder')" />
                      <div class="input-group-append">
                        <button v-if="!isSearching" class="btn btn-primary" type="button" @click="search" :disabled="isSearchButtonDisabled || !searchInputName || !searchInputId"
                          style="height: 50px">
                          {{ $t("message.find_person.search") }}
                        </button>
                        <button v-else class="btn btn-primary" type="button" disabled style="height: 50px">
                          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                          {{ $t("message.find_person.searching") }}...
                        </button>
                      </div>
                    </div>
                    <div class="mt-3">
                      <div v-if="isSearching">
                        <h4>{{ $t("message.find_person.searching") }}...</h4>
                      </div>
                      <div v-else-if="isSearched && !resultsExists">
                        {{ $t("message.find_person.no_results") }}
                      </div>
                      <div v-else-if="isSearched && resultsExists" class="mt-4">
                        <ListView :data="response" />
                      </div>
                      <div></div>
                    </div>
                  </b-tab>
                  <b-tab :title="$t('message.find_person.history')" lazy id="history-tab">
                    <History />
                  </b-tab>
                </b-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ListView from "./components/list-view.vue"
import History from "./history.vue"

export default {
  inject: ["runBiller", "updateBiller"],
  components: { ListView, History },
  data() {
    return {
      tab_index: 0,
      isSearchButtonDisabled: false,
      isSearching: false,
      isSearched: false,

      searchInputName: "",
      searchInputId: "",
      type: {
        value: "",
        display_text: this.$t("message.find_person.types.all"),
      },

      response: {
        allList: null,
        cpwsList: null,
        ktggList: null,
        zxggList: null,
        shixinList: null,
        fyggList: null,
        ajlcList: null,
        bgtList: null,
        sifacdkList: null,
        pmggList: null,

        searchInputName: null,
        resultsScore: null,
        resp_code: null,
      },

      all_types: [
        {
          value: "",
          display_text: this.$t("message.find_person.types.all"),
        },
        {
          value: "cpws",
          display_text: this.$t("message.find_person.types.cpws"),
        },
        {
          value: "ktgg",
          display_text: this.$t("message.find_person.types.ktgg"),
        },
        {
          value: "zxgg",
          display_text: this.$t("message.find_person.types.zxgg"),
        },
        {
          value: "shixin",
          display_text: this.$t("message.find_person.types.shixin"),
        },
        {
          value: "fygg",
          display_text: this.$t("message.find_person.types.fygg"),
        },
        {
          value: "ajlc",
          display_text: this.$t("message.find_person.types.ajlc"),
        },
        {
          value: "bgt",
          display_text: this.$t("message.find_person.types.bgt"),
        },
        {
          value: "sifacdk",
          display_text: this.$t("message.find_person.types.sifacdk"),
        },
        {
          value: "pmgg",
          display_text: this.$t("message.find_person.types.pmgg"),
        },
      ],
    };
  },
  async mounted() {
    if (!this.$store.state.auth) this.$router.push({ name: "sign-in" });
  },
  methods: {
    disableSearchForSomeTime() {
      this.isSearchButtonDisabled = true;
      new Noty({
        type: "success",
        theme: "light",
        text: this.$t("message.request_processing"),
        timeout: 5000,
        progressBar: true,
      }).show();
      setTimeout(() => {
        this.isSearchButtonDisabled = false;
      }, 20000);
    },

    async search() {
      const searchKeyword = `[${this.searchInputName}, ${this.searchInputId}]`;
      const reduceBalanceId = await this.runBiller("100", searchKeyword);
      if (!reduceBalanceId) {
        return;
      }
      this.disableSearchForSomeTime();
      this.isSearching = true;
      this.isSearched = false;
      try {
        await this._getPersonalLegalInfoList();
      } catch (e) {
        console.error("_getPersonalLegalInfoList", e);
      }
      this.updateBiller(reduceBalanceId, this.resultsExists);
      this.isSearched = true;
      this.isSearching = false;
    },
    async _getPersonalLegalInfoList() {
      const formData = new FormData();
      formData.append("name", this.searchInputName);
      formData.append("idcard", this.searchInputId);
      formData.append("dataType", this.type.value);
      formData.append("pageno", 1);
      formData.append("locale", this.$i18n.locale);
      formData.append("signalRConnectionId", window.signalRConnectionId);
      const res = await axios.post(window.base + "/PersonalLegalInfo/GetPersonalLegalInfoList", formData);
      this.response.allList = (res.data || {})?.resp_data?.allList || null;
      this.response.cpwsList = (res.data || {})?.resp_data?.cpwsList || null;
      this.response.ktggList = (res.data || {})?.resp_data?.ktggList || null;
      this.response.zxggList = (res.data || {})?.resp_data?.zxggList || null;
      this.response.shixinList = (res.data || {})?.resp_data?.shixinList || null;
      this.response.fyggList = (res.data || {})?.resp_data?.fyggList || null;
      this.response.ajlcList = (res.data || {})?.resp_data?.ajlcList || null;
      this.response.bgtList = (res.data || {})?.resp_data?.bgtList || null;
      this.response.sifacdkList = (res.data || {})?.resp_data?.sifacdkList || null;
      this.response.pmggList = (res.data || {})?.resp_data?.pmggList || null;
      this.response.resultsScore = (res.data || {})?.police_info?.data?.score || null;
      this.response.resp_code = (res.data || {})?.resp_code || null;
      this.response.searchInputName = this.searchInputName;
    },
    policeInfoToType(policeInfoResult) {
      policeInfoResult = policeInfoResult || 0;
      // Point. [20,30) - wanted, [30,40) - drugs, [40,50) - drug involvement, [50,60) - criminal history,
      // 60 - people with mental illness, protesters, terrorists and others. (60,100] - not included in the category
      // Балл. [20,30) – в розыске, [30,40) - наркотики, [40,50) - причастность к наркотикам, [50,60) - уголовное прошлое,
      // 60 - люди с психическими заболеваниями, протестующие, террористы и другие. (60,100] - нет попадания в категорию
      let type = "";
      if (policeInfoResult < 20) { type = "0-20" }
      else if (policeInfoResult < 30) { type = "20-30" }
      else if (policeInfoResult < 40) { type = "30-40" }
      else if (policeInfoResult < 50) { type = "40-50" }
      else if (policeInfoResult < 60) { type = "50-60" }
      else if (policeInfoResult === 60) { type = "60" }
      else if (policeInfoResult > 60) { type = "60-100" }
      const _string = this.$t(`message.find_person.results_type.${type}`)
      return `${policeInfoResult} (${_string})`;
    },
  },
  computed: {
    resultsExists() {
      return Boolean(
        (Array.isArray(this.response.allList) && this.response.allList.length) ||
        (Array.isArray(this.response.cpwsList) && this.response.cpwsList.length) ||
        (Array.isArray(this.response.ktggList) && this.response.ktggList.length) ||
        (Array.isArray(this.response.zxggList) && this.response.zxggList.length) ||
        (Array.isArray(this.response.shixinList) && this.response.shixinList.length) ||
        (Array.isArray(this.response.fyggList) && this.response.fyggList.length) ||
        (Array.isArray(this.response.ajlcList) && this.response.ajlcList.length) ||
        (Array.isArray(this.response.bgtList) && this.response.bgtList.length) ||
        (Array.isArray(this.response.sifacdkList) && this.response.sifacdkList.length) ||
        (Array.isArray(this.response.pmggList) && this.response.pmggList.length) ||
        this.response.resp_code === "SW0000"
      );
    },
  },
  provide() {
    return {
      policeInfoToType: this.policeInfoToType,
    }
  },
  watch: {},
};
</script>
<style>
.modal-footer .btn.btn-success.btn-sm:hover {
  background-color: #4caf50 !important;
  border-color: #4caf50 !important;
}
.modal-footer .btn.btn-secondary.btn-sm:hover {
  color: #333333 !important;
}
@media (max-width: 767.98px) {
  .find-person-input-group {
    flex-direction: column;
    align-items: stretch;
  }
  .find-person-input-group > * {
    width: 100% !important;
    margin-bottom: 10px !important;
    border-radius: 8px !important;
  }
  .find-person-input-group .input-group-append {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .find-person-input-group .btn {
    width: 100%;
  }
}
</style>
